import React, { useState } from 'react'
import Icon from '../../icon';
import './captainCardExtras.css';
import './captainChangeSheet.css';
import { Popup, Toast } from 'antd-mobile';
import { colorList } from '../ApplicateTwo/color';

const ChooseCaptain = ({ gameDetail, memberList, greenTeamName, redTeamName, memberInfo, onUpdateCaptain }) => {

    const [editingSide, setEditingSide] = useState(null);
    const [selectedCaptainId, setSelectedCaptainId] = useState(null);
    const [selectedColor, setSelectedColor] = useState(null);

    const greenCaptain = memberList?.find(item => item.id === gameDetail?.greenCaptainId)
    const redCaptain = memberList?.find(item => item.id === gameDetail?.redCaptainId)

    // Dynamic team colors from gameDetail
    const greenColor = gameDetail?.greenColor || '#10b981';
    const redColor = gameDetail?.redColor || '#ef4444';

    const getMemberImage = (member, colorType) => {
        if (!member) return Icon.KEPENG_LOGO;
        // Logic to try and find the best matching jersey image
        // 1=Green, 2=Red, 5=Substitute/Other
        let image;
        if (colorType === 'red') {
            image = member?.memberImageList?.find(item => item.type === 2)?.image;
            if (!image) image = member?.memberImageList?.find(item => item.type === 1)?.image;
        } else if (colorType === 'green') {
            image = member?.memberImageList?.find(item => item.type === 1)?.image;
            if (!image) image = member?.memberImageList?.find(item => item.type === 2)?.image;
        } else if (colorType === "#CCCCFF") {
            image = member?.memberImageList?.find(item => item.type === 5)?.image;
            if (!image) image = member?.memberImageList?.find(item => item.type === 1)?.image;
        }

        // Fallback to other or default
        if (!image) image = member?.memberImageList?.find(item => item.type === 5)?.image;

        return image ? (image + Icon.ImageFooter) : Icon.KEPENG_LOGO;
    }

    // 修改队长时沿用原候选范围，只将选择流程移入底部面板。
    const candidateList = memberList?.filter(item =>
        item.gameType !== null && item.gameType <= 4 && item.tempMember === null && item.standingMember === 1
    ) || [];

    const openCaptainSheet = (isRed) => {
        if (memberInfo?.admin !== 1) return;
        if (candidateList.length === 0) {
            Toast.show({ content: '没有可选的常委成员' });
            return;
        }
        setSelectedCaptainId(isRed ? gameDetail.redCaptainId : gameDetail.greenCaptainId);
        setSelectedColor(isRed ? (gameDetail.redColor || 'red') : (gameDetail.greenColor || 'green'));
        setEditingSide(isRed ? 'red' : 'green');
    };

    const saveCaptain = () => {
        if (!selectedCaptainId) {
            Toast.show({ content: '请选择队长' });
            return;
        }
        const isRed = editingSide === 'red';
        const dto = {
            gameId: gameDetail.id,
            redCaptainId: isRed ? selectedCaptainId : gameDetail.redCaptainId,
            greenCaptainId: isRed ? gameDetail.greenCaptainId : selectedCaptainId,
            redColor: isRed ? selectedColor : gameDetail.redColor,
            greenColor: isRed ? gameDetail.greenColor : selectedColor
        };
        setEditingSide(null);
        onUpdateCaptain(dto);
    };

    const renderCaptainCard = (captain, teamColor, teamName, isRed) => {
        const hasCaptain = !!captain;
        const teamClass = hasCaptain ? (isRed ? 'team-red' : 'team-green') : '';
        const cardStyle = hasCaptain ? { '--team-color': teamColor } : {};
        const isAdmin = memberInfo?.admin === 1;

        return (
            <div
                className={`command-captain-card ${teamClass} ${isAdmin ? 'clickable' : ''}`}
                style={cardStyle}
                onClick={() => isAdmin && openCaptainSheet(isRed)}
            >
                <div className="command-card-content">
                    <div className="captain-avatar-core">
                        <div className="avatar-pulse-ring"></div>
                        <img
                            src={getMemberImage(captain, teamColor)}
                            alt={captain?.name}
                            className="command-avatar-img"
                        />
                        {teamColor === '#CCCCFF' && <div className="command-crown">👑</div>}
                    </div>

                    <div className="command-info">
                        <div className="command-name">{captain?.name || '待定'}</div>
                        <div className="team-identity-label">
                            <span className="team-indicator-dot"></span>
                            {teamName} 统帅
                        </div>
                    </div>
                </div>
                {isAdmin && <div className="admin-edit-badge">点击修改</div>}
            </div>
        );
    };

    return (
        <div className="versus-captains-container">
            <div className="versus-captains-header">
                <div className="versus-captains-title-group">
                    <span className="versus-captains-title">比赛队长</span>
                    <span className="versus-captains-subtitle">MATCH CAPTAINS</span>
                </div>
            </div>

            <div className="versus-captains-grid">
                {renderCaptainCard(greenCaptain || gameDetail?.greenCaptain, greenColor, greenTeamName || 'A队', false)}

                <div className="versus-separator">
                    <span className="vs-icon-text">VS</span>
                </div>

                {renderCaptainCard(redCaptain || gameDetail?.redCaptain, redColor, redTeamName || 'B队', true)}
            </div>
            <Popup
                visible={editingSide !== null}
                onMaskClick={() => setEditingSide(null)}
                bodyStyle={{ borderTopLeftRadius: 22, borderTopRightRadius: 22, overflow: 'hidden' }}
                style={{ '--z-index': 1250 }}
            >
                <div className="captain-change-sheet">
                    <div className="captain-change-header">
                        <button type="button" onClick={() => setEditingSide(null)}>取消</button>
                        <div>
                            <strong>修改比赛队长</strong>
                            <span>{editingSide === 'red' ? redTeamName || 'B队' : greenTeamName || 'A队'}</span>
                        </div>
                        <span className="captain-change-header-spacer" />
                    </div>
                    <div className="captain-change-content">
                        <div className="captain-change-label">选择队长</div>
                        <div className="captain-change-members">
                            {candidateList.map(item => (
                                <button
                                    key={item.id}
                                    type="button"
                                    className={`captain-change-member ${selectedCaptainId === item.id ? 'active' : ''}`}
                                    aria-pressed={selectedCaptainId === item.id}
                                    onClick={() => setSelectedCaptainId(item.id)}
                                >
                                    <img src={getMemberImage(item, selectedColor)} alt="" />
                                    <span>{item.name}</span>
                                </button>
                            ))}
                        </div>
                        <div className="captain-change-label">队服颜色</div>
                        <div className="captain-change-colors">
                            {colorList.map(color => (
                                <button
                                    key={color.value}
                                    type="button"
                                    className={`captain-change-color ${selectedColor === color.value ? 'active' : ''}`}
                                    aria-pressed={selectedColor === color.value}
                                    onClick={() => setSelectedColor(color.value)}
                                >
                                    <span className="captain-change-swatch" style={{ background: color.value }} />
                                    {color.name}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="captain-change-footer">
                        <button type="button" onClick={saveCaptain}>保存修改</button>
                    </div>
                </div>
            </Popup>
        </div>
    )
}

export default ChooseCaptain;
